export default class LocationSearchAnalytics {
  constructor(store, container) {
    this.store = store;
    this.container = container;
    this.cookiesAccepted = false;
    this.analyticsUrl = this.container.dataset.analyticsUrl;

    document.addEventListener("non-functional-cookies-accepted", () => {
      this.cookiesAccepted = true;
    });
  }
  
  getDirectusData(locationName) {
    const data = {
      event_type: this.store.activeTypeValue || "none",
      capacity: this.store.minimumCapacity,
      lineup: this.store.selectedLineup || "all",
    };
    if (locationName) {
      data.location = locationName;
    }
    return data;
  }

  getGtmData(locationName) {
    const data = {
      location_event_type: this.store.activeTypeValue || "none",
      location_capacity: this.store.minimumCapacity,
      location_lineup: this.store.selectedLineup || "all",
    };
    if (locationName) {
      data.location_picked_name = locationName;
    }
    return data;
  }

  sendEvent(eventName, locationName) {
    try {
      const gaData = this.getGtmData(locationName);

      if (window && window.dataLayer) {
        window.dataLayer.push({ event: eventName, ...gaData });
      }
      if (this.analyticsUrl) {
        const directusPayload = this.getDirectusData(locationName);

        fetch(this.analyticsUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(directusPayload),
        });
      }
    } catch (error) {
      console.error("Error sending analytics event:", error);
    }
  }


  trackSearchResults() {
    this.sendEvent("location_filter_results");
  }

  trackLocationClick(locationName) {
    console.log("Location clicked:", locationName);
    this.sendEvent("location_click", locationName );
  }
}